import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import DataGrid from 'app/components/DataGrid';
import useResource from 'app/hooks/useResource';
import BillingModal from './BillingModal';

import {
  getBillings,
  setBillingParams
} from 'app/actions/billings';

import {
  createBilling,
  updateBilling,
  destroyBilling,
  getBillings as exportBillings
} from 'app/services/billings';

import {
  billings as resource
} from 'app/resources';

const Billings = (props) => {
  const { getBillings, setBillingParams } = props;
  const header = 'Billings';
  const getRowData = getBillings;
  const addButtonLabel = 'Add Billing';
  const columnOrder = ['name', 'address', 'city', 'state', 'zip', 'email'];
  const visibleColumns = ['name', 'address', 'city', 'state', 'zip', 'email'];

  const {
    onAdd,
    onEdit,
    formIsOpen,
    currentRecord,
    onDataGridLoad,
    onFormSubmit,
    onFormClose,
    onDestroy,
    showFilters,
    getFilterModel
  } = useResource({
    resource,
    getResource: getBillings,
    createResource: createBilling,
    updateResource: updateBilling,
    destroyResource: destroyBilling,
    setResourceParams: setBillingParams,
  });

  const columnDefOverrides = [
    {
      field: 'name',
      headerName: 'Name',
      quickEdit: true
    },
    {
      field: 'address',
      headerName: 'Address',
      quickEdit: true
    },
    {
      field: 'city',
      headerName: 'City',
      quickEdit: true
    },
    {
      field: 'state',
      headerName: 'State',
      quickEdit: true
    },
    {
      field: 'zip',
      headerName: 'Zip',
      quickEdit: true
    },
    {
      field: 'state',
      headerName: 'State',
      quickEdit: true
    }
  ]

  const destroyAction = (row) => {
    return destroyBilling(row.id)
  }

  const exportCSV = async (row) => {
    let params = {
      page: 0,
      per_page: 1000,
      is_export: true
    }

    const filterModel = getFilterModel();
    if (filterModel) {
      params.filter_model = filterModel;
    }

    exportBillings(params).then((resp => resp.blob())).then((blob) => {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = `billing_entities_${new Date().toISOString()}.csv`;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    })
  }

  const actions = [
    { key: 'destroy', label: 'Delete Billing Entities', callback: destroyAction }
  ]

  const buttons = [
    {
      key: 'export',
      icon: <FileDownloadIcon />,
      label: 'CSV',
      onClick: exportCSV
    }
  ]

  return (
    <div>
      <DataGrid
        resource={resource}
        header={header}
        getRowData={getRowData}
        addButtonLabel={addButtonLabel}
        onAdd={onAdd}
        showEdit={true}
        onEdit={onEdit}
        showQuickEdit={true}
        showSelect={true}
        loadingMessage="Loading billings..."
        columnOrder={columnOrder}
        visibleColumns={visibleColumns}
        columnDefOverrides={columnDefOverrides}
        showFilters={showFilters}
        onDataGridLoad={onDataGridLoad}
        actions={actions}
        buttons={buttons}
      />
      <BillingModal
        isOpen={formIsOpen}
        onClose={onFormClose}
        onFormSubmit={onFormSubmit}
        billing={currentRecord}
        onDestroy={onDestroy}
      />
    </div>
  )
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { getBillings, setBillingParams })(withRouter(Billings));
